import { TypeOf, yup } from '@guiker/shared-framework'

import { createSeriesSchema } from './create-series-schema'

export const updateStockSeriesSchema = yup.object({ series: createSeriesSchema })

export type UpdateStockSeriesSchema = TypeOf<typeof updateStockSeriesSchema>
